import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const ArrowLeftSmall = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <g transform="translate(2 2)">
        <g transform="translate(2)">
          <path
            d="M3.293 6.707l5 5a1 1 0 1 0 1.414-1.414L5.414 6l4.293-4.293A1 1 0 1 0 8.293.293l-5 5a1 1 0 0 0 0 1.414z"
            transform="translate(-3)"
          />
        </g>
      </g>
    </svg>
  );
};

ArrowLeftSmall.displayName = 'ArrowLeftSmall';
